import { render, staticRenderFns } from "./MedicineDetails.vue?vue&type=template&id=7f9d4930&scoped=true"
import script from "./MedicineDetails.vue?vue&type=script&lang=js"
export * from "./MedicineDetails.vue?vue&type=script&lang=js"
import style0 from "./MedicineDetails.vue?vue&type=style&index=0&id=7f9d4930&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9d4930",
  null
  
)

export default component.exports